"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("..");
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _awsAmplify = require("aws-amplify");
var _EditableTable = require("./EditableTable");
var _WebRequestHelper = require("../../helpers/WebRequestHelper");
var _v = _interopRequireDefault(require("uuid/v1"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = (state, props) => {
  return {
    [props.entity.plural]: state[props.entity.plural]
  };
};
const mapDispatchToProps = (dispatch, props) => {
  return {
    create: (0, _redux.bindActionCreators)(props.actions.create, dispatch)
  };
};
class CreateTranslationsTable extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "newEntry", () => {
      const emptyRow = {
        category: "",
        translationId: "",
        valueGerman: "",
        valueEnglish: "",
        comment: ""
      };
      this.setState(state => {
        return {
          ...state,
          list: [...state.list, emptyRow]
        };
      });
    });
    _defineProperty(this, "handleChangeElement", (e, element) => {
      const code = e.keyCode ? e.keyCode : e.which;
      if (code === 13) {
        // If 'Enter' key is pressed, add new row

        return this.newEntry(element);
      }
      const row = element.rowNumber;
      const name = element.name;
      const newList = this.state.list;
      newList.map((item, index) => {
        if (index === row) {
          item[name] = e.target.value;
        }
      });
      this.setState({
        ...this.state,
        list: newList
      });
    });
    _defineProperty(this, "createTranslations", event => {
      event.preventDefault();
      this.state.list.map((element, rowIndex) => {
        if (!Object.values(element).some(x => x !== null && x !== "")) {
          // The row is empty

          this.throw(`All elements must have at least a Translation ID and a value in English`);
          return false;
        } else if (!element.translationId || !element.valueEnglish) {
          // Row not empty, but something is missing

          this.setState({
            fetching: false
          });
          this.throw(`All elements must have at least a Translation ID and a value in English`);
          return false;
        }
        let germanElement = {
          LanguageId: this.state.languagesId.german,
          TranslationId: element.translationId,
          Value: element.valueGerman,
          Category: element.category,
          Comment: element.comment
        };
        let englishElement = {
          LanguageId: this.state.languagesId.english,
          TranslationId: element.translationId,
          Value: element.valueEnglish,
          Category: element.category,
          Comment: element.comment
        };
        let elementsArray = [];
        if (germanElement.Value) {
          elementsArray.push(germanElement);
        }
        if (englishElement.Value) {
          elementsArray.push(englishElement);
        }
        this.setState({
          fetching: true,
          errors: [],
          messages: []
        });
        if (elementsArray) {
          this.sendTranslationEntries(elementsArray);
        }
      });
    });
    _defineProperty(this, "sendTranslationEntries", elementsArray => {
      const {
        create
      } = this.props;
      elementsArray.map((body, elementIndex) => {
        this.setState({
          fetching: true
        });
        _awsAmplify.Auth.currentSession().then(data => {
          create(JSON.stringify(body), data.idToken.jwtToken).then(response => {
            if (elementIndex === elementsArray.length - 1) {
              this.message(`Text successfully created.`);
              let idToDelete = response.TranslationId;
              this.setState(state => {
                const filteredList = this.state.list.filter(item => item.translationId !== idToDelete);
                return {
                  ...state,
                  list: filteredList
                };
              });
              this.newEntry();
              this.setState({
                fetching: false
              });
            }
          }).catch(error => {
            console.dir(error);
            this.throw(`You probably tried to create a Translation ID that already exists.`);
            this.setState({
              fetching: false
            });
          });
        }).catch(error => {
          console.dir(error);
          this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
          this.setState({
            fetching: false
          });
        });
      });
    });
    _defineProperty(this, "throw", message => {
      this.setState(prev => {
        return {
          errors: [{
            Id: (0, _v.default)(),
            Message: message
          }]
        };
      });
    });
    _defineProperty(this, "message", message => {
      this.setState(prev => {
        return {
          messages: [{
            Id: (0, _v.default)(),
            Message: message
          }]
        };
      });
    });
    this.state = {
      tableHeaders: [{
        displayName: "Category"
      }, {
        displayName: "Translation ID"
      }, {
        displayName: "Value in German"
      }, {
        displayName: "Value in English"
      }, {
        displayName: "Comment"
      }],
      list: [{
        category: "",
        translationId: "",
        valueGerman: "",
        valueEnglish: "",
        comment: ""
      }],
      languagesId: {},
      fetching: false,
      errors: [],
      messages: []
    };
  }
  componentDidMount() {
    /**
     * Gets all the languages, then searches for German and English. If any of them is not found, throws an error.
     */

    (0, _WebRequestHelper.createRequest)(true).then(request => {
      request.method = "get";
      request.url = `/languages`;
      (0, _WebRequestHelper.sendRequest)(request).then(response => {
        console.log(response);
        let englishId, germanId;
        response.data.forEach(language => {
          if (language.Code === "de-DE") {
            germanId = language.Id;
          } else if (language.Code === "en-US") {
            englishId = language.Id;
          }
        });
        if (!englishId || !germanId) {
          this.throw(`English or German language is not in the system. Please check again`);
        }
        this.setState(prevState => ({
          ...prevState,
          languagesId: {
            ...prevState.languagesId,
            german: germanId,
            english: englishId
          }
        }));
        console.log(this.state);
      }).catch(err => console.dir(err));
    }).catch(err => console.dir(err));
  }
  onRead(id) {
    this.setState(prev => {
      return {
        errors: prev.errors.filter(error => error.Id !== id),
        messages: prev.messages.filter(message => message.Id !== id)
      };
    });
  }
  render() {
    const {
      fetching,
      tableHeaders,
      list,
      errors,
      messages
    } = this.state;
    if (fetching) return /*#__PURE__*/_react.default.createElement(_.Spinner, null);
    return /*#__PURE__*/_react.default.createElement("div", null, !!errors.length && errors.map(error => /*#__PURE__*/_react.default.createElement("div", {
      key: error.Id,
      className: "alert alert-danger alert-dismissible fade show mb-4"
    }, error.Message.length < 200 ? error.Message : "Oops, something went wrong.", /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: () => this.onRead(error.Id)
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7")))), !!messages.length && messages.map(message => /*#__PURE__*/_react.default.createElement("div", {
      key: message.Id,
      className: "alert alert-success alert-dismissible fade show mb-4"
    }, message.Message, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: () => this.onRead(message.Id)
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7")))), /*#__PURE__*/_react.default.createElement("div", {
      className: "mt-2 mb-3"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-secondary mr-4",
      onClick: this.newEntry
    }, "\uFF0B New Row"), list[0] && list[0].category && list[0].translationId && list[0].valueEnglish ? /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-primary",
      onClick: this.createTranslations
    }, "Save") : /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-primary disabled",
      onClick: this.createTranslations,
      disabled: true
    }, "Save")), /*#__PURE__*/_react.default.createElement("table", {
      className: "table table-hover mt-4 mb-4"
    }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, tableHeaders.map((column, index) => /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      key: index,
      className: "table-header align-top"
    }, column.displayName)))), /*#__PURE__*/_react.default.createElement("tbody", null, list.map((row, index) => {
      return /*#__PURE__*/_react.default.createElement(_EditableTable.EditableRow, {
        list: list,
        rowNumber: index,
        row: row,
        key: index,
        onChange: this.handleChangeElement
      });
    }))), /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-secondary mr-4",
      onClick: element => this.newEntry(element)
    }, "\uFF0B New Row"), list[0] && list[0].category && list[0].translationId && list[0].valueEnglish ? /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-primary",
      onClick: this.createTranslations
    }, "Save") : /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-primary disabled",
      onClick: this.createTranslations,
      disabled: true
    }, "Save"));
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CreateTranslationsTable);
module.exports = exports.default;